import { openDB } from "idb";

const DB_NAME = "carthi-share-db";
const STORE_NAME = "shared-car-photo-from-otherapp";

//  Open DB
export const getDB = () =>
  openDB(DB_NAME, 1, {
    upgrade(db) {
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, {
          keyPath: "id",
          autoIncrement: true,
        });
      }
    },
  });

//  Save files
export const saveSharedFiles = async (files) => {
  const db = await getDB();
  const tx = db.transaction(STORE_NAME, "readwrite");

  for (const file of files) {
    await tx.store.add({
      file,
      createdAt: Date.now(),
    });
  }
  await tx.done;
};

//  Get + Clear files
export const getAndClearSharedFiles = async () => {
  const db = await getDB();

  const all = await db.getAll(STORE_NAME);
  await db.clear(STORE_NAME);

  return all.map((item) => item.file);
};
export const getSharedFiles = async () => {
  const db = await getDB();

  const all = await db.getAll(STORE_NAME);
  // await db.clear(STORE_NAME);

  return (all || [])?.map((item) => item.file);
};

export const clearSharedFiles = async () => {
  const db = await getDB();
  await db.clear(STORE_NAME);
};
